import React from 'react';
import "./Qualifications.css";
import point from "../../assets/bulletpoint.svg"
import lightblue from "../../assets/lightblue.svg"
import background from "../../assets/background.svg"
import middlebackgr from  "../../assets/middlebackgr.svg"
import leftbackgr from "../../assets/leftbackgr.svg"
import bg from "../../assets/icons/bg.svg"
import WaheedIcon from "../../assets/icons/waheedIcon.png"; 
// import waheedFace from "../../assets/waheedface.svg"
import crwon22 from "../../assets/icons/crown22.svg"
import crown21 from "../../assets/icons/crown21.svg"
import crown16 from "../../assets/icons/crown16.svg"
import crown13 from "../../assets/icons/crown13.svg"
import { useTranslation } from "react-i18next";

export default function Qualifications() {
    const { t, i18n } = useTranslation();
  
  return (
    <section id="qualifications">
      <div className="qualification-container">
        <h1>
          <img src={lightblue} className="lightblue" />
          <img src={point} className="point" />
          {t("qualifications")}
          <img src={point} className="point" />
        </h1>
        <div className="qualification-content-container">
          <div className="qualification-content-text">
            <div className="qualification-content">
              <div className="qualification-text">
                <h4 className="qualification-p">{t("qualification_p")}</h4>
              </div>
            </div>
            <div className="qualifications">
              <div className="qualification-item">
                <div className="qualification-info">
                  <h4>{t("mba")}</h4>
                  <h3>{t("arab_college")}</h3>
                </div>
                <img src={crwon22} alt="Crown 22" />
              </div>
              <div className="qualification-item">
                <div className="qualification-info">
                  <h4>{t("advisor")}</h4>
                  <h3>{t("saudi_institute")}</h3>
                </div>
                <img src={crown21} alt="Crown 21" />
              </div>
              <div className="qualification-item">
                <div className="qualification-info">
                  <h4>{t("restructuring")}</h4>
                  <h3>{t("leadership_institute")}</h3>
                </div>
                <img src={crown16} alt="Crown 16" />
              </div>
              <div className="qualification-item">
                <div className="qualification-info">
                  <h4>{t("bachelor_degree")}</h4>
                  <h3>{t("imam_university")}</h3>
                </div>
                <img src={crown13} alt="Crown 13" />
              </div>
            </div>
          </div>
          <div className="waheed">
            <img src={leftbackgr} alt="left-bg" className="left-bg" />
            <img src={background} alt="right-bg" className="right-bg" />
            <img src={bg} alt="waheedLogo" className="bg" />
            <img src={middlebackgr} alt="mid-bg" className="mid-bg" />
            <img src={WaheedIcon} alt="Waheed" className="waheed-face" />
          </div>
        </div>
        <img src={bg} alt="bg" className="waheedbg" />
      </div>
    </section>
  );
}
